import {LuSpeech} from 'react-icons/lu'
 
export const SpeechToTextOptions = ({
  selectedClient,
  loading,
  handleSubmit,
  handleToggle,
  handleNameChange,
  speechToTextOptions,
}) => {
  return (
    <div className="card shadow-sm border-0 fade-in">
      <div className="card-header text-white">
        <h5 className="card-title mb-0">
             <span style={{ marginRight: '10px' }}><LuSpeech /></span>
          Manage Speech-to-Text Options
        </h5>
        <small>
          Enable speech-to-text providers and assign a display name that will be visible to the
          client.
        </small>
      </div>

      <div className="card-body">
        {loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {Object.entries(speechToTextOptions).map(([key, option]) => (
              <div
                className="mb-4 p-3 border rounded-2 shadow-sm"
                key={key}
                style={{ backgroundColor: '#f9f9f9' }}
              >
                <div className="form-group custom-control custom-checkbox mb-2 d-flex align-items-center">
                  <input
                    className="custom-control-input me-2"
                    type="checkbox"
                    id={`stt-${key}`}
                    checked={option.status}
                    onChange={() => handleToggle(key)}
                  />
                  <label
                    className="custom-control-label fw-semibold mb-0"
                    htmlFor={`stt-${key}`}
                    style={{ fontSize: '1rem' }}
                  >
                    Enable {option.label}
                  </label>
                </div>

                <input
                  type="text"
                  className="form-control mt-1"
                  placeholder={`Enter display name for ${option.label}`}
                  value={option.name}
                  onChange={e => handleNameChange(key, e.target.value)}
                />

                <small className="text-muted mt-1 d-block">
                  This name will be displayed to the client in dropdowns and UI elements.
                </small>
              </div>
            ))}
          </form>
        )}
      </div>
    </div>
  );
};
